import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-tools-roller-icon',
  templateUrl: './tools-roller.component.html'
})
export class ToolsRollerComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
